import {
  DIM2CLASS
} from '../core/icon-class';

require('./filter-search.component.scss');

class FilterSearchController {
  constructor(
    $scope,
    $http,
    CurrentFilterService,
    AggregateDataService,
    CurrentModelService,
    RouterService,
    FilterResource,
  ) {
    this.$scope = $scope;
    this.$http = $http;
    this.currentFilter = CurrentFilterService;
    this.filterBar = CurrentFilterService.filterBar;
    this.DIM2CLASS = DIM2CLASS;
    this.AggregateDataService = AggregateDataService;
    this.CurrentModelService = CurrentModelService;
    this.router = RouterService;
    this.FilterResource = FilterResource;
    this.value = '';
    this.previousValue = this.value;
    this.oper = '@';
    this.placeholders = {
      '+': gettext('Поиск - Подстрока'),
      '@': gettext('Поиск - Ключевое слово'),
      '~': gettext('Поиск - Регулярное выражение'),
    };
    // this.title = gettext('Поиск - Ключевые слова');
    // this.titleCatalog = gettext('Поиск - Имя фильтра');
  }

  get placeholder() {
    return this.placeholders[this.oper];
  }

  get panel() {
    return this.currentFilter.panel;
  }

  set panel(panel) {
    this.currentFilter.panel = panel;
  }

  get filter() {
    return this.currentFilter.filter;
  }

  set filter(filter) {
    this.currentFilter.filter = filter;
  }

  searchKeyup(event) {
    if (event.keyCode !== 13) {
      return;
    }
    return this.search();
  }

  searchClean() {
    this.value = '';
    this.search();
  }

  getKeywordsArr(str) {
    let wBegin = 0;
    let isQuoted = false;
    const arr = [];
    let i = 0;
    for (i; i < str.length; i++) {
      if (!isQuoted && str[i] == ' ') {
        if (i - wBegin) arr.push(str.substr(wBegin, i - wBegin).trim());
        wBegin = i + 1;
      } else if (!isQuoted && str[i] == '"') {
        if (i - wBegin) arr.push(str.substr(wBegin, i - wBegin).trim());
        wBegin = i + 1;
        isQuoted = true;
      } else if (isQuoted && str[i] == '"') {
        isQuoted = false;
        if (i - wBegin) arr.push(str.substr(wBegin, i - wBegin).trim());
        wBegin = i + 1;
      }
    }
    if (i - wBegin) arr.push(str.substr(wBegin, i - wBegin).trim());
    return arr;
  }


  search() {
    if (this.router.isFilterEditModal) {
      this.$scope.runClick({
        keyWord: this.value,
        oper: this.oper,
      });
      // this.$scope.runClick(this.value);
    } else {
      const keywords = this.value;
      if (!keywords.trim()) {
        return;
      }

      const addKeywords = keywords => {
        keywords.map(keyword => {
          this.router.addKeyword(keyword, [this.oper]);
        });
        this.value = '';
        if (!this.$scope.$root.$$phase) this.$scope.$root.$apply();
      };

      const keywordsArr = this.getKeywordsArr(keywords);
      if (this.oper === '~') {
        this.FilterResource.checkRegExps(keywordsArr)
          .then(err => {
            if (err) {
              this.error = err;
              if (!this.$scope.$root.$$phase) this.$scope.$root.$apply();
              return null;
            }
            addKeywords(keywordsArr);
          });
      } else {
        addKeywords(keywordsArr);
      }
    }
  }
}

export function FilterSearchComponent() {
  return {
    restrict: 'E',
    template: require('./filter-search.component.html'),
    // scope: true,
    scope: {
      runClick: '&'
    },
    controller: FilterSearchController,
    controllerAs: '$ctrl',
  };
}



// WEBPACK FOOTER //
// ./src/filter/filter-search.component.js